import * as React from 'react';

const SVGBranchFinder: React.SFC<SvgProps> = props => (
  <svg width={14} height={21} {...props}>
    <g strokeWidth={1.2} stroke="#B0BDC0" fill="none" fillRule="evenodd">
      <path d="M7.025 19.857h-.129a.512.512 0 0 1-.512-.507v-1.691s0-1.86-1.368-3.213C2.96 12.12 1.913 10.794 1.442 8.748a7.798 7.798 0 0 1-.186-1.742c0-3.162 2.615-5.75 5.811-5.75 3.196 0 5.811 2.588 5.811 5.75 0 .585-.055 1.172-.186 1.742-.47 2.046-1.517 3.372-3.574 5.698-1.367 1.353-1.367 3.213-1.367 3.213v1.69c0 .28-.23.508-.513.508H7.025z" />
      <path d="M8.777 7.067a1.71 1.71 0 1 1-3.42 0 1.71 1.71 0 0 1 3.42 0z" />
    </g>
  </svg>
);

export default SVGBranchFinder;
